import { useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useSobreNosTab } from "../../../contexts/SobreNosTabContext";
import Breadcrumb from "../../breadcrumb";
import DefaultText from "../../typography/default-text";
import BannerText from "./BannerText";
import styles from "./styles.module.css";
import { bannerTexts } from "./texts";

const PageBanner: React.FC = () => {

  const isMobile = useMediaQuery("(max-width: 899px)");
  const [text, setText] = useState<BannerText>();
  const pageContext = useLocation().pathname.split("/")[1];
  const pageName = useLocation().pathname.split("/")[2];
  const { activeTab } = useSobreNosTab();

  useEffect(() => {
    const getText = (): BannerText | undefined => {
      if (pageContext === "empresa" && pageName === "sobre-nos") {
        return bannerTexts.find(text => text.pageName === activeTab);
      }
      
      if (pageContext !== "empresa" && pageContext !== "servicos") {
        return bannerTexts.find(text => text.pageName === pageContext);
      } else {
        return bannerTexts.find(text => text.pageName === pageName);
      }
    }
    
    const pageBannerText = getText();
    setText(pageBannerText);
  }, [pageName, pageContext, activeTab])

  return (
    <div className={styles["page-banner-wrapper"]}>
      <div 
        className={styles["page-banner-container"]}
        data-page={text?.pageName}
        style={{
          '--bg-image': text?.backgroundImage ? `url(${text.backgroundImage})` : 'none'
        } as React.CSSProperties}
      >
      <Breadcrumb />
      <div className={styles["banner-text-content"]}>
        <div>
          {text?.headingItalic &&
            <DefaultText 
              color="var(--primary-white)" 
              size={isMobile ? "small" : "medium"} 
              sx={{ 
                fontFamily: "Montserrat-Italic",
                fontSize: isMobile ? "25px" : "32px",
                marginBottom: 0,
                lineHeight: 1
              }}
            >
              {text.headingItalic}
            </DefaultText>
          }
          {text?.headingBold &&
            <DefaultText 
              color="var(--primary-white)" 
              lineHeight={isMobile ? "25px" : "48px"} 
              size={isMobile ? "small" : "x-large"} 
              sx={{ 
                fontFamily: "Montserrat-Bold",
                fontSize: isMobile ? "32px" : "48px",
                marginTop: 0,
                lineHeight: 1
              }}
            >
              {text?.headingBold}
            </DefaultText>
          }
        </div>
        {(text?.descriptionDesktop || text?.descriptionMobile) &&
          <DefaultText 
            color="var(--primary-white)" 
            size={isMobile ? "xs" : "small"} 
            sx={{ 
              fontFamily: "Montserrat-Regular",
              fontSize: isMobile ? "16px" : "20px"
            }}
          >
            {text?.descriptionDesktop &&
              <div 
                className={styles["text-container-desktop"]}
                dangerouslySetInnerHTML={{ __html: text.descriptionDesktop }}
              />
            }
            {text?.descriptionMobile &&
              <div 
                className={styles["text-container-mobile"]}
                dangerouslySetInnerHTML={{ __html: text.descriptionMobile }}
              />
            }
          </DefaultText>
        }
      </div>
    </div>
    </div>
  );
};

export default PageBanner;
